import {styled} from "@mui/material";

export const PaymentResultContainer = styled('div')(() => {
    return {
        display: 'flex',
    }
});
